import type { ActivationFunnel, FunnelStage, FunnelStageId } from '../../services/analytics';
import { formatInt } from './format';

export const FUNNEL_STAGE_LABELS: Record<FunnelStageId, string> = {
    cadastrou: 'Cadastrou',
    primeiro_login: '1º acesso',
    pesquisa: 'Pesquisa',
    primeiro_lancamento: '1º lançamento',
    retornou_d7: 'Retornou D7',
    crfa: 'CRFA',
};

export interface FunnelSegment {
    stage: FunnelStage;
    label: string;
    /** Largura (0-100) no topo e na base do trecho. A base e a largura da proxima etapa. */
    topPct: number;
    bottomPct: number;
}

const clamp = (v: number | null): number => (v === null ? 0 : Math.max(0, Math.min(100, v)));

/**
 * Cada etapa ocupa uma faixa: abre na largura do proprio percentual e fecha na
 * largura da etapa seguinte. A ultima etapa fica reta.
 */
export function buildFunnelSegments(stages: FunnelStage[]): FunnelSegment[] {
    return stages.map((stage, i) => {
        const topPct = clamp(stage.pct);
        const next = stages[i + 1];
        return {
            stage,
            label: FUNNEL_STAGE_LABELS[stage.id],
            topPct,
            bottomPct: next ? clamp(next.pct) : topPct,
        };
    });
}

/** Poligono centralizado (clip-path) de um trecho do funil. Largura zero nos dois lados nao desenha nada. */
export function funnelPolygon(topPct: number, bottomPct: number): string {
    const x = (w: number, side: 'l' | 'r') => (side === 'l' ? (100 - w) / 2 : (100 + w) / 2);
    const n = (v: number) => `${Math.round(v * 100) / 100}%`;
    return `polygon(${n(x(topPct, 'l'))} 0, ${n(x(topPct, 'r'))} 0, ${n(x(bottomPct, 'r'))} 100%, ${n(x(bottomPct, 'l'))} 100%)`;
}

/** "3 contas com 7 dias de observação". */
export function observationNote(funil: ActivationFunnel): string {
    if (funil.base <= 0) return 'Sem contas com 7 dias de observação';
    return `${formatInt(funil.base)} ${funil.base === 1 ? 'conta' : 'contas'} com 7 dias de observação`;
}
